<script setup lang="ts">
const props = defineProps<{
  time: string;
  tapState: { x: number; y: number; active: boolean };
}>();
</script>

<template>
  <div class="phone-frame">
    <div class="phone-screen dark">
      <!-- Tap Indicator Overlay -->
      <div v-if="tapState.active" class="tap-indicator" :style="{ left: tapState.x + 'px', top: tapState.y + 'px' }"></div>

      <!-- Status Bar -->
      <div class="status-bar">
        <span class="time">{{ time }}</span>
        <div class="status-icons">
          <div class="ios-signal"><span></span><span></span><span></span><span></span></div>
          <i class="pi pi-wifi"></i>
          <i class="pi pi-battery-full"></i>
        </div>
      </div>

      <slot></slot>
    </div>
  </div>
</template>

<style scoped>
.phone-frame {
  width: 320px; height: 660px;
  background: #000; border-radius: 44px; border: 12px solid #1a1a1a;
  position: relative; overflow: hidden;
  box-shadow: 0 40px 100px rgba(0,0,0,0.8);
}

.phone-screen {
  width: 100%; height: 100%; background: #000;
  display: flex; flex-direction: column; position: relative;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
}

.tap-indicator {
  position: absolute; width: 40px; height: 40px;
  background: rgba(255, 255, 255, 0.4); border-radius: 50%;
  transform: translate(-50%, -50%); z-index: 1000;
  pointer-events: none; animation: tapRipple 0.4s ease-out forwards;
}
@keyframes tapRipple { from { transform: translate(-50%, -50%) scale(0.5); opacity: 1; } to { transform: translate(-50%, -50%) scale(2); opacity: 0; } }

.status-bar { height: 36px; padding: 0 16px; display: flex; justify-content: space-between; align-items: center; color: #fff; font-size: 11px; font-weight: 600; z-index: 100; }
.status-icons { display: flex; gap: 6px; align-items: center; }
.ios-signal { display: flex; gap: 2px; align-items: flex-end; height: 10px; }
.ios-signal span { width: 3px; background: #fff; border-radius: 1px; }
.ios-signal span:nth-child(1) { height: 40%; }
.ios-signal span:nth-child(2) { height: 60%; }
.ios-signal span:nth-child(3) { height: 80%; }
.ios-signal span:nth-child(4) { height: 100%; opacity: 0.3; }
</style>
